import React from "react";
import ExerciseScrollArea from "./ExerciseScrollArea";
import PropTypes from "prop-types";

import DraggableExerciseCard from "../dnd/DraggableExerciseCard";

export default function ExerciseList({ exercises }) {
  return (
    <ExerciseScrollArea>
      {exercises.map((ex) => (
        <DraggableExerciseCard key={ex.id} exercise={ex} />
      ))}
    </ExerciseScrollArea>
  );
}

ExerciseList.propTypes = {
  exercises: PropTypes.array.isRequired,
};
